import React, {Component} from "react";
import {Button, message, Switch ,Input, Radio,Form,Icon,Select,Card,Modal} from 'antd';
import getSize from "../../../utils/getSize";
import NHFetch from "../../../utils/NHFetch";
import {hasAuth} from "../../../utils/NHCore";
import NHTable from '../../common/NHTable';
import {NHConfirm} from '../../common/NHModal';
import NHContainerFrame from '../../common/NHContainerFrame';
import NHFormItem from '../../common/NHFormItem';
import NHSelect from '../../common/NHSelect/index'

const { TextArea } = Input;
const RadioGroup = Radio.Group;
class EditInitForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {
        const { form } = this.props;
        const editData=this.props.editData?this.props.editData:{};

        return (
            <Form>
                <NHFormItem label="对接方式名称" id={'djfsmc'} form={form} initialValue={editData.DJFSMC} required={true}>
                    <Input placeholder={'请输入对接方式名称...'} />
                </NHFormItem>
                {
                    editData.DJFSID?<NHFormItem label="对接方式标志" id={'djfsid'} form={form} initialValue={editData.DJFSID} required={true}>
                        <Input placeholder={'请输入对接方式标志...'} disabled={true}/>
                    </NHFormItem>:<NHFormItem label="对接方式标志" id={'djfsid'} form={form} initialValue={editData.DJFSID} required={true}>
                        <Input placeholder={'请输入对接方式标志...'} />
                    </NHFormItem>
                }
                
                <NHFormItem label="是否需要同步按钮" id={'sfxytban'} form={form} initialValue={editData.SFXYTBAN?editData.SFXYTBAN:"0"} required={true}>
                    <RadioGroup>
                        <Radio value={"0"}>不需要</Radio>
                        <Radio value={"1"}>需要</Radio>
                    </RadioGroup>
                </NHFormItem>
                <NHFormItem label="是否需要记录订单" id={'sfxyjldd'} form={form} initialValue={editData.SFXYJLDD?editData.SFXYJLDD:"0"} required={true}>
                    <RadioGroup>
                        <Radio value={"0"}>不需要</Radio>
                        <Radio value={"1"}>需要</Radio>
                    </RadioGroup>
                </NHFormItem>
                <NHFormItem label="对接方式描述" id={'djfsms'} form={form} initialValue={editData.DJFSMS}>
                    <TextArea placeholder={'请输入对接方式描述...'} rows={3}/>
                </NHFormItem>
            </Form>
        );
    }
}

const EditForm = Form.create()(EditInitForm);
export default EditForm;


// WEBPACK FOOTER //
// ./components/zxjfgl/jffagl/EditForm.js